module.exports = __webpack_public_path__ + "img/202403_03.696a812c.jpg";